import Vue from 'vue';
import ElementUI from 'element-ui';
import FoxUI from '@fox-js/foxui-pc';
import './index.scss';
import './custom.css';

Vue.use( ElementUI );
Vue.use( FoxUI, {
    //head bar height
    headBarHeight: 74 + 50, //(标题栏高度+面包屑标签高度）1122
    //foot bar height
    footBarHeight: 0,
    // page layout
    pageLayout: {
        headerHeight: 40,
        footerHeight: 84
    },
    // 默认的label位置
    labelPosition: 'top',
    //默认label宽度
    labelWidth: '138px',
    //输入item的最小宽度
    minItemWidth: 250,
    //item的间隔
    itemSpacing: 32,
    //label显示最大字数
    labelMaxCharCount: 16,
    // clear hotkey
    clearHotkey: 'F1',
    // expand hotkey
    expandHotkey: 'F2',
    // select hotkey
    selectHotkey: 'Enter',
    //导航事件触发策略
    navigateEventTriggerPolicy: 'inPage', // inPage:焦点在本页面触发 or ignore:不触发焦点时间 or none:正常触发焦点事件
} );
